module.exports = __webpack_public_path__ + "static/media/7homsen.cde2d741.svg";